import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Navbar from 'react-bootstrap/Navbar';
import { faBook, faBan, faStore, faP, faS, faGlobeAmericas, faPersonCirclePlus, faList, faUser, faPrint, faDownload, faLocationArrow, faBuilding, faListCheck, faComment, faSitemap, faCog, faBuildingColumns, faMagnifyingGlass, faMinusCircle, faMoneyBill, faTable, faTrash, faUndo, faArchive, faShareSquare, faUndoAlt, faCalculator, faUserCircle, faRuble, faArrowAltCircleUp, faTasksAlt, faFile, faStepBackward, faTimesCircle, faListOl, faHistory, faCheck, faComments, faCommenting, faCommentSms, faUsers, faSignOut, faLandmark, faCalendar, faCopyright, faMoneyBill1, faFileInvoiceDollar, faFileInvoice, faUserGear, faHandshake, faSliders } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Offcanvas, Row, Spinner } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import MenuService from './services/menuService';
import UsuarioService from './services/usuarioService';
import OriginadorService from './services/originadorService';
import { MenuDTO, SubmenuDTO, ItemDTO } from './shared/dto/menuDTO';
import { Link, useNavigate } from 'react-router-dom';
import { useSlug } from './pages/hooks/UseSlug';
import { useLayout } from '../contexts/LayoutContext';
import { Originador } from './shared/model/originador';

const customItemOrder: Record<string, number> = {
  'Matriz': 1,
  'Originador': 2,
  'Regional': 3,
  'Comercial': 4,
  'Promotora': 5,
  'Promotora Gestão': 6,
  'Gestão Promotora': 6,
  'Supervisor': 7,
  'Operador': 8,
  'Ponto de Venda': 9,
};

function NavBar() {
  const nomeUsuario = localStorage.getItem('nome');
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [menus, setMenus] = useState<MenuDTO[]>([]);

  const [listaOriginadores, setListaOriginadores] = useState<any[]>([]);

  // ADICIONADO: Estado para controlar o loading da troca
  const [loadingTroca, setLoadingTroca] = useState(false);

  const logoPadraoFictor = '/BPO/logomarca.png';

  const logoEnv = process.env.REACT_APP_LOGO_PATH;


  const slug = useSlug();
  const navigate = useNavigate();
  const logoutPath = slug ? `/${slug}/login` : '/login';
  const { layout } = useLayout();

  const menuService: MenuService = new MenuService();
  const usuarioService = new UsuarioService();
  const originadorService = new OriginadorService();



  const logoPadrao = logoEnv;
  let logoParaExibir = logoPadrao;
  if (layout.logoBase64) {
    logoParaExibir = layout.logoBase64;
  } else if (layout.logoUrl) {
    logoParaExibir = layout.logoUrl;
  }

  const listarMenuPorRole = async () => {
    try {
      const responseList = await menuService.listarMenuPorRole();
      setMenus(processarMenus(responseList.data));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const carregarOriginadores = async () => {
      const loginSalvo = localStorage.getItem('id') || '';

      if (loginSalvo) {
        try {
          const response = await usuarioService.listarUsuarioComOrigemPorIdOriginador(loginSalvo);
          if (response && response.data) {
            setListaOriginadores(response.data);
          }
        } catch (error) {
          console.error("Erro ao carregar lista de originadores para troca", error);
        }
      }
    };

    if (nomeUsuario) {
      carregarOriginadores();
    }
  }, [nomeUsuario]);

  const handleTrocarOriginador = async (idOrigem: string, nomeOrigem: string) => {
    try {
      setLoadingTroca(true);
      console.log(`Trocando para originador: ${nomeOrigem} ID: ${idOrigem}`);

      const response = await originadorService.listarOriginadorPorId(idOrigem);

      if (response && response.data && response.data.slug) {
        const novoSlug = response.data.slug;
        navigate(`/${novoSlug}/home`);
        handleClose();
      } else {
        console.warn('Não foi possível encontrar o slug para o originador selecionado.');
      }

    } catch (error) {
      console.error('Erro ao trocar originador:', error);
    } finally {
      setLoadingTroca(false);
    }
  };

  const navegarPara = (caminho: string) => {
    if (!caminho) return;
    const caminhoLimpo = caminho.startsWith('/') ? caminho.substring(1) : caminho;
    const destino = slug ? `/${slug}/${caminhoLimpo}` : `/${caminhoLimpo}`;

    navigate(destino);
    handleClose();
  };

  const processarMenus = (data: any[]): MenuDTO[] => {
    if (!Array.isArray(data)) {
      console.error('Os dados recebidos não são um array:', data);
      return [];
    }

    const menuMap: Record<string, MenuDTO> = {};
    const submenuMap: Record<string, SubmenuDTO> = {};

    data.forEach((item) => {
      const menu = item.idMenu;
      if (!menu) {
        console.warn('Menu não encontrado em item:', item);
        return;
      }

      const {
        nome = '',
        iconMenu = '',
        rota = '',
        nomeSubmenu = '',
        iconSubmenu = '',
        nomeItem = null,
        iconItem = null,
      } = menu;

      if (!menuMap[nome]) {
        menuMap[nome] = new MenuDTO();
        menuMap[nome].nome = nome;
        menuMap[nome].icone = iconMenu;
        menuMap[nome].rota = '';
        menuMap[nome].submenus = [];
      }

      if (!nomeSubmenu) {
        return;
      }

      if (nomeSubmenu && !nomeItem) {
        const sub = new SubmenuDTO();
        sub.nome = nomeSubmenu;
        sub.icone = iconSubmenu;
        sub.rota = rota;
        sub.items = [];
        menuMap[nome].submenus.push(sub);
      }

      if (nomeSubmenu && nomeItem) {

        const submenuKey = `${nome}_${nomeSubmenu}`;
        if (!submenuMap[submenuKey]) {
          const novoSubmenu = new SubmenuDTO();
          novoSubmenu.nome = nomeSubmenu;
          novoSubmenu.icone = iconSubmenu;
          novoSubmenu.rota = '';
          novoSubmenu.items = [];

          submenuMap[submenuKey] = novoSubmenu;
          menuMap[nome].submenus.push(novoSubmenu);
        }

        const novoItem = new ItemDTO();
        novoItem.nome = nomeItem;
        novoItem.icone = iconItem;
        novoItem.rota = rota;

        submenuMap[submenuKey].items.push(novoItem);
      }

    });

    let menusFinais = Object.values(menuMap);

    const ordenarPorPrioridade = (a: any, b: any) => {
      const prioridadeA = customItemOrder[a.nome] || 999;
      const prioridadeB = customItemOrder[b.nome] || 999;
      return prioridadeA - prioridadeB;
    };

    menusFinais.sort(ordenarPorPrioridade);

    menusFinais.forEach(menu => {
      if (menu.submenus && menu.submenus.length > 0) {
        menu.submenus.sort(ordenarPorPrioridade);
      }

      if (menu.submenus) {
        menu.submenus.forEach(submenu => {
          if (submenu.items && submenu.items.length > 0) {
            submenu.items.sort(ordenarPorPrioridade);
          }
        });
      }
    });

    return menusFinais;
  };


  const verificarRotaMenuRapido = (rota: string): boolean => {
    if (!rota || menus.length === 0) return false;

    const rotaLimpa = rota.startsWith('/') ? rota.substring(1) : rota;

    return menus.some(menu =>
      (menu.rota && menu.rota.includes(rotaLimpa)) ||
      (menu.submenus && menu.submenus.some(submenu => submenu.rota.includes(rotaLimpa)))
    );
  };
  useEffect(() => {
    if (nomeUsuario) {
      listarMenuPorRole();
    }
  }, [nomeUsuario]);

  const logoPath = process.env.REACT_APP_LOGO_PATH;

  return (
    <div style={{ width: '100%' }}>
      {/* ADICIONADO: Overlay de Loading */}
      {loadingTroca && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
          <h5 className="mt-3 text-primary">Alterando {Originador.DESCRITIVO_GERAL}...</h5>
        </div>
      )}

      <div className="row align-items-center">
        <Navbar expand="lg" className="row align-items-center">
          <Row>
            {/* MENU LATERAL */}
            <Container style={{ marginLeft: '30px', display: 'flex', justifyContent: 'space-between' }}>
              <Offcanvas show={show} onHide={handleClose} placement="start">
                <Offcanvas.Header closeButton>
                  <Link to={slug ? `/${slug}/home` : '/home'}>
                    <Image width={"130px"} src={logoParaExibir} fluid />
                  </Link>
                </Offcanvas.Header>
                <Offcanvas.Title style={{ display: 'flex', justifyContent: 'center' }}>{nomeUsuario && <span style={{ marginLeft: '19px', fontWeight: 'bold', alignItems: 'center' }}>Olá, {nomeUsuario}</span>}</Offcanvas.Title>
                <Nav.Item style={{ display: 'flex', justifyContent: 'center', fontSize: '12px' }}>
                  <Nav.Link onClick={() => navegarPara('alterar-senha')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                    <FontAwesomeIcon icon={faCog} className="animated-icon" style={{ marginRight: '5px' }} />
                    Alterar senha
                  </Nav.Link>
                </Nav.Item>

                <Offcanvas.Body>
                  {nomeUsuario && menus.length > 0 ? (
                    menus
                      .filter((menu: any) => menu.nome !== 'Consulta Dossiê')
                      .map((menu: any) => (
                        <div key={menu.nome} style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                          <FontAwesomeIcon icon={faIconsMap[menu.icone]} style={{ marginRight: '8px' }} />

                          {menu.submenus.length > 0 ? (
                            <NavDropdown title={<span>{menu.nome}</span>}>
                              {menu.submenus
                                .filter((submenu: any) => submenu.nome !== 'Consulta Dossiê')
                                .map((submenu: any) => (
                                  submenu.items && submenu.items.length > 0 ? (
                                    <NavDropdown
                                      key={submenu.nome}
                                      title={
                                        <span>
                                          <FontAwesomeIcon icon={faIconsMap[submenu.icone]} style={{ marginRight: '5px' }} />
                                          {submenu.nome}
                                        </span>
                                      }
                                    >
                                      {submenu.items
                                        .filter((item: any) => item.nome !== 'Consulta Dossiê')
                                        .map((item: any) => (
                                          <NavDropdown.Item key={item.nome} onClick={() => navegarPara(item.rota)}>
                                            <FontAwesomeIcon icon={faIconsMap[item.icone]} style={{ marginRight: '5px' }} />
                                            {item.nome}
                                          </NavDropdown.Item>
                                        ))}
                                    </NavDropdown>
                                  ) : (
                                    <NavDropdown.Item key={submenu.nome} onClick={() => navegarPara(submenu.rota)}>
                                      <FontAwesomeIcon icon={faIconsMap[submenu.icone]} style={{ marginRight: '5px' }} />
                                      {submenu.nome}
                                    </NavDropdown.Item>
                                  )
                                ))}
                            </NavDropdown>
                          ) : (
                            <Nav.Link onClick={() => navegarPara(menu.rota)} style={{ display: 'flex', alignItems: 'center' }}>
                              {menu.nome}
                            </Nav.Link>
                          )}
                        </div>
                      ))
                  ) : (
                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                      {nomeUsuario && <span>Carregando menus...</span>}
                    </div>
                  )}

                  {listaOriginadores.length > 1 && (
                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: '10px' }}>
                      <FontAwesomeIcon icon={faBuilding} style={{ marginTop: '5px' }} />
                      <NavDropdown title={`Mudar ${Originador.DESCRITIVO_GERAL}`} style={{ marginLeft: '11px' }}>
                        {listaOriginadores.map((item) => (
                          <NavDropdown.Item
                            key={item.id}
                            onClick={() => handleTrocarOriginador(item.idOrigem, item.nomeOrigem)}
                          >
                            <FontAwesomeIcon
                              icon={faArrowAltCircleUp}
                              style={{ marginRight: '3px', marginLeft: '-13px' }}
                            />
                            {item.nomeOrigem}
                          </NavDropdown.Item>
                        ))}
                      </NavDropdown>
                    </div>
                  )}


                  {/* <div style={{ display: 'flex', flexDirection: 'row', marginTop: '10px' }}>
                    <FontAwesomeIcon icon={faMoneyBill1} style={{ marginTop: '5px' }} />
                    <NavDropdown title="Comissão" style={{ marginLeft: '11px' }}>
                      <NavDropdown.Item href="/comissao/tipo">
                        <FontAwesomeIcon icon={faListCheck} style={{ marginRight: '3px', marginLeft: '-13px' }} />
                        Tipo de Comissão
                      </NavDropdown.Item>

                      <NavDropdown.Item href="/comissao/regras">
                        <FontAwesomeIcon icon={faListCheck} style={{ marginRight: '3px', marginLeft: '-13px' }} />
                        Regras de Comissão
                      </NavDropdown.Item>

                      <NavDropdown.Item href="/comissao/fatura">
                        <FontAwesomeIcon icon={faFileInvoiceDollar} style={{ marginRight: '3px', marginLeft: '-13px' }} />
                        Faturas
                      </NavDropdown.Item>

                      <NavDropdown.Item href="/comissao/notafiscal">
                        <FontAwesomeIcon icon={faFileInvoice} style={{ marginRight: '3px', marginLeft: '-13px' }} />
                        Notas Fiscais
                      </NavDropdown.Item>

                      <NavDropdown.Item href="/comissao/financeiro">
                        <FontAwesomeIcon icon={faUserGear} style={{ marginRight: '3px', marginLeft: '-13px' }} />
                        Portal Financeiro
                      </NavDropdown.Item>

                      <NavDropdown.Item href="/comissao/extorno">
                        <FontAwesomeIcon icon={faUserGear} style={{ marginRight: '3px', marginLeft: '-13px' }} />
                        Estornos
                      </NavDropdown.Item>

                      <NavDropdown.Item href="/comissao/negociacoes">
                        <FontAwesomeIcon icon={faHandshake} style={{ marginRight: '3px', marginLeft: '-13px' }} />
                        Negociações
                      </NavDropdown.Item>

                      <NavDropdown.Item href="/comissao/parametros">
                        <FontAwesomeIcon icon={faSliders} style={{ marginRight: '3px', marginLeft: '-13px' }} />
                        Parâmetros
                      </NavDropdown.Item>

                      <NavDropdown title={<span><FontAwesomeIcon icon={faList} style={{ marginTop: '11px', marginRight: '5px' }} />Relatórios</span>} id="contrato-dropdown">
                        <NavDropdown.Item href="/comissao/relatorio-faturas">
                          <FontAwesomeIcon icon={faFileInvoiceDollar} style={{ marginRight: '6px' }} />
                          Faturas
                        </NavDropdown.Item>
                      </NavDropdown>

                    </NavDropdown>

                  </div> */}


                  <div style={{ marginTop: '25px', width: '100%', justifyContent: 'center', display: 'flex' }}>
                    <Button variant="outline-danger" onClick={() => navigate(logoutPath)}>
                      <FontAwesomeIcon icon={faSignOut} style={{ marginRight: '15px' }} />Sair
                    </Button>
                  </div>
                </Offcanvas.Body>

              </Offcanvas>

              <Navbar.Toggle
                as={Button}
                onClick={handleShow}
                variant="primary"
                id="App-button-cor-principal-escura"
                style={{ marginLeft: '5px' }}
              >
                <FontAwesomeIcon icon={faList} />
              </Navbar.Toggle>

            </Container>
          </Row>
        </Navbar>

        <div className="col-md-2">
          {/* MENU ACIMA */}
          <Navbar expand="lg" className="row align-items-center">
            {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
            <Navbar.Collapse id="basic-navbar-nav">
              <Button id="App-button-cor-principal-escura" style={{ marginLeft: '5px' }} variant="primary" onClick={handleShow}>
                <FontAwesomeIcon icon={faList} />
              </Button>

              <Nav className="justify-content-center flex-grow-1 pe-3" style={{ marginLeft: '120%' }}>
                {/* PROPOSTA */}
                {verificarRotaMenuRapido('/proposta-cartao') && (
                  <Nav.Item>
                    <Nav.Link onClick={() => navegarPara('proposta-cartao')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                      <FontAwesomeIcon icon={faCalculator} />
                      Simulação - Cartão
                    </Nav.Link>
                  </Nav.Item>
                )}

                {/* ESTEIRA */}
                {verificarRotaMenuRapido('/esteira-proposta/FLUXO') && (
                  <Nav.Item>
                    <Nav.Link onClick={() => navegarPara('esteira-proposta/FLUXO')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                      <FontAwesomeIcon icon={faList} style={{ marginRight: '5px' }} />
                      Esteira - Propostas
                    </Nav.Link>
                  </Nav.Item>
                )}
                {verificarRotaMenuRapido('/esteira-proposta/LOTE') && (
                  <Nav.Item>
                    <Nav.Link onClick={() => navegarPara('esteira-proposta/LOTE')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                      <FontAwesomeIcon icon={faTasksAlt} style={{ marginRight: '5px' }} />
                      Esteira - Processamento em Lote
                    </Nav.Link>
                  </Nav.Item>
                )}

                {/* CLIENTE */}
                {/* <FontAwesomeIcon icon={faUser} style={{ marginTop: '11px' }} />
                <NavDropdown title="Clientes" id="basic-nav-dropdown">
                  <NavDropdown.Item href="/cliente-consulta/LIMITE">
                    <FontAwesomeIcon icon={faMagnifyingGlass} style={{ marginRight: '5px' }} />Consulta Limite
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/cliente-consulta/ATUALIZACAO">
                    <FontAwesomeIcon icon={faUserCircle} style={{ marginRight: '5px' }} />Atualização Cadastral
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/cliente-consulta-historico">
                    <FontAwesomeIcon icon={faHistory} style={{ marginRight: '5px' }} />Consulta Histórico
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/cliente-aprovar-atualizacao">
                    <FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />Aprovar Atualização
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/cliente-relatorio">
                    <FontAwesomeIcon icon={faList} style={{ marginRight: '5px' }} />Relatório de Clientes
                  </NavDropdown.Item>
                </NavDropdown> */}

                {/* RELATORIOS */}
                {verificarRotaMenuRapido('/relatorio-analitico') && (
                  <Nav.Item>
                    <Nav.Link onClick={() => navegarPara('esteira-proposta/FLUXO')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                      <FontAwesomeIcon icon={faListOl} style={{ marginRight: '5px' }} />
                      Relatório - Produção Analítico
                    </Nav.Link>
                  </Nav.Item>
                )}

                {/* <Nav.Item>
                  <Nav.Link onClick={() => window.location.href = '/relatorio-extrato-mensal'} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                    <FontAwesomeIcon icon={faListOl} style={{ marginRight: '5px' }} />
                    Relatório - Extrato Mensal
                  </Nav.Link>
                </Nav.Item> */}

                {/* ORIGENS */}
                {/* <FontAwesomeIcon icon={faBuilding} style={{ marginTop: '11px' }} />
                <NavDropdown title="Origens" id="basic-nav-dropdown">
                  <NavDropdown.Item href="/origens-matriz">
                    <FontAwesomeIcon icon={faBuilding} style={{ marginRight: '5px' }} />Matriz
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/origens-promotora">
                    <FontAwesomeIcon icon={faBuilding} style={{ marginRight: '5px' }} />Promotora
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/origens-supervisor">
                    <FontAwesomeIcon icon={faUserCircle} style={{ marginRight: '5px' }} />Supervisor
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/origens-operador">
                    <FontAwesomeIcon icon={faUserCircle} style={{ marginRight: '5px' }} />Operador
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/origens-ponto-venda">
                    <FontAwesomeIcon icon={faBuilding} style={{ marginRight: '5px' }} />Ponto de Venda
                  </NavDropdown.Item>
                </NavDropdown> */}

                {/* PARAMETROS CARTAO */}
                {/* <FontAwesomeIcon icon={faListCheck} style={{ marginTop: '11px' }} />
                <NavDropdown title="Parâmetros Cartão" id="basic-nav-dropdown">
                  <NavDropdown.Item href="/parametros-esteira">
                    <FontAwesomeIcon icon={faList} style={{ marginRight: '5px' }} />Esteiras
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/parametros-produto">
                    <FontAwesomeIcon icon={faRuble} style={{ marginRight: '5px' }} />Produtos
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/parametros-empregador">
                    <FontAwesomeIcon icon={faBuilding} style={{ marginRight: '5px' }} />Empregadores
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/parametros-financiamento">
                    <FontAwesomeIcon icon={faCalculator} style={{ marginRight: '5px' }} />Tabela de Financiamento
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/motivo-recusa">
                    <FontAwesomeIcon icon={faList} style={{ marginRight: '5px' }} />Motivos Recusa/Pendência
                  </NavDropdown.Item>
                </NavDropdown> */}

                {/* COMUNICADOS */}
                {/* <FontAwesomeIcon icon={faComment} style={{ marginTop: '11px' }} />
                <NavDropdown title="Comunicados" id="basic-nav-dropdown">
                  <NavDropdown.Item href="/comunicados-vigentes">
                    <FontAwesomeIcon icon={faComment} style={{ marginRight: '5px' }} />Comunicados Vigentes
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/comunicados-tipos">
                    <FontAwesomeIcon icon={faCommenting} style={{ marginRight: '5px' }} />Tipos de Comunicados
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/comunicados">
                    <FontAwesomeIcon icon={faComments} style={{ marginRight: '5px' }} />Comunicados
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/comunicados-confirmacao">
                    <FontAwesomeIcon icon={faCommentSms} style={{ marginRight: '5px' }} />Confirmação de Comunicados
                  </NavDropdown.Item>
                </NavDropdown> */}

                {/* SISTEMA */}
                {/* <FontAwesomeIcon icon={faSitemap} style={{ marginTop: '11px' }} />
                <NavDropdown title="Sistema" id="basic-nav-dropdown">
                  <NavDropdown.Item href="/sistema-parametros-ti">
                    <FontAwesomeIcon icon={faCog} style={{ marginTop: '11px', marginRight: '5px' }} />Parâmetros TI
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/sistema-usuario">
                    <FontAwesomeIcon icon={faUsers} style={{ marginTop: '11px', marginRight: '5px' }} />Usuários
                  </NavDropdown.Item>
                </NavDropdown> */}

                {/* BACKOFFICE */}
                {/* <FontAwesomeIcon icon={faBuildingColumns} style={{ marginTop: '11px' }} />
                <NavDropdown title="BackOffice" id="basic-nav-dropdown">
                  <NavDropdown.Item href="/backoffice-contrato/consulta">
                    <FontAwesomeIcon icon={faMagnifyingGlass} style={{ marginRight: '5px' }} />Consulta de Contrato
                  </NavDropdown.Item>
                  <NavDropdown title={<span><FontAwesomeIcon icon={faSitemap} style={{ marginTop: '11px', marginRight: '5px' }} />Lançamentos</span>} id="contrato-dropdown">
                    <NavDropdown.Item href="/backoffice-lancamentos/baixa-parcela/">
                      <FontAwesomeIcon icon={faMoneyBill} style={{ marginRight: '5px' }} />Baixa de Parcelas - Manual
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/backoffice-contrato/prorrogacao-vencimento">
                      <FontAwesomeIcon icon={faMinusCircle} style={{ marginRight: '5px' }} />Prorrogação de Vencimentos - Manual
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/backoffice-arquivo-lote/LANCAMENTO">
                      <FontAwesomeIcon icon={faArchive} style={{ marginRight: '5px' }} />Processos Em Lote
                    </NavDropdown.Item> */}

                {/* BACKOFFICE - LANCAMENTOS */}
                {/* <NavDropdown.Item href="/backoffice-lancamentos/estorno-parcela">
                      <FontAwesomeIcon icon={faMinusCircle} style={{ marginRight: '5px' }} />Estorno de Parcela
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/backoffice-lancamentos/cancelamento-movimentacao">
                      <FontAwesomeIcon icon={faTrash} style={{ marginRight: '5px' }} />Cancelamento de Movimentação
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/backoffice-lancamentos/estorno-operacao">
                      <FontAwesomeIcon icon={faUndo} style={{ marginRight: '5px' }} />Estorno de Operação
                    </NavDropdown.Item>
                  </NavDropdown> */}

                {/* BACKOFFICE - CESSAO */}
                {/* <NavDropdown title={<span><FontAwesomeIcon icon={faMoneyBill} style={{ marginTop: '11px', marginRight: '5px' }} />Cessão</span>} id="contrato-dropdown">
                    <NavDropdown.Item href="/backoffice-cessao/lancamento-manual">
                      <FontAwesomeIcon icon={faShareSquare} style={{ marginRight: '5px' }} />Lançamento Manual
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/backoffice-cessao/recompra-manual">
                      <FontAwesomeIcon icon={faUndoAlt} style={{ marginRight: '5px' }} />Recompra Manual
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/backoffice-arquivo-lote/CESSAO">
                      <FontAwesomeIcon icon={faArchive} style={{ marginRight: '5px' }} />Processos Em Lote
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/backoffice-cessao/remessa-liquidacao">
                      <FontAwesomeIcon icon={faArrowAltCircleUp} style={{ marginRight: '5px' }} />Remessa Liquidação
                    </NavDropdown.Item>
                  </NavDropdown> */}

                {/* BACKOFFICE -RELATORIOS */}
                {/* <NavDropdown title={<span><FontAwesomeIcon icon={faList} style={{ marginTop: '11px', marginRight: '5px' }} />Relatórios</span>} id="contrato-dropdown">
                    <NavDropdown.Item href="/backoffice-relatorios/operacoes-realizadas/">
                      <FontAwesomeIcon icon={faList} style={{ marginRight: '5px' }} />Operações Realizadas
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/backoffice-relatorios/vencimentos">
                      <FontAwesomeIcon icon={faList} style={{ marginRight: '5px' }} />De Vencimentos
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/backoffice-relatorios/movimentacao-financeira">
                      <FontAwesomeIcon icon={faList} style={{ marginRight: '5px' }} />Movimentação Financeira
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/backoffice-relatorios/contratos-cedidos">
                      <FontAwesomeIcon icon={faList} style={{ marginRight: '5px' }} />Contratos Cedidos
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/backoffice-relatorios/parcelas-cedidas">
                      <FontAwesomeIcon icon={faList} style={{ marginRight: '5px' }} />Parcelas Cedidas
                    </NavDropdown.Item>
                  </NavDropdown> */}

                {/* BACKOFFICE - TABELAS */}
                {/* <NavDropdown title={<span><FontAwesomeIcon icon={faTable} style={{ marginTop: '11px', marginRight: '5px' }} />Tabelas</span>} id="contrato-dropdown">
                    <NavDropdown.Item href="/backoffice-tabelas/historico-financeiro/">
                      <FontAwesomeIcon icon={faBook} style={{ marginRight: '5px' }} />Histórico Financeiro
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/backoffice-tabelas/fidc">
                      <FontAwesomeIcon icon={faBook} style={{ marginRight: '5px' }} />FIDC
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/backoffice-tabelas/cessao">
                      <FontAwesomeIcon icon={faBook} style={{ marginRight: '5px' }} />Cessão
                    </NavDropdown.Item>
                  </NavDropdown>
                </NavDropdown> */}
              </Nav>

            </Navbar.Collapse>

          </Navbar>
        </div>
      </div>
    </div >
  );
}

const faIconsMap: Record<string, any> = {
  faBan: faBan,
  faBook: faBook,
  faList: faList,
  faUser: faUser,
  faPrint: faPrint,
  faBuilding: faBuilding,
  faListCheck: faListCheck,
  faComment: faComment,
  faSitemap: faSitemap,
  faCog: faCog,
  faBuildingColumns: faBuildingColumns,
  faMagnifyingGlass: faMagnifyingGlass,
  faMinusCircle: faMinusCircle,
  faMoneyBill: faMoneyBill,
  faTable: faTable,
  faTrash: faTrash,
  faUndo: faUndo,
  faArchive: faArchive,
  faShareSquare: faShareSquare,
  faUndoAlt: faUndoAlt,
  faCalculator: faCalculator,
  faUserCircle: faUserCircle,
  faRuble: faRuble,
  faArrowAltCircleUp: faArrowAltCircleUp,
  faTasksAlt: faTasksAlt,
  faFile: faFile,
  faStepBackward: faStepBackward,
  faTimesCircle: faTimesCircle,
  faListOl: faListOl,
  faHistory: faHistory,
  faCheck: faCheck,
  faComments: faComments,
  faCommenting: faCommenting,
  faCommentSms: faCommentSms,
  faUsers: faUsers,
  faCalendar: faCalendar,
  faLandmark: faLandmark,
  faCopyright: faCopyright,
  faGlobeAmericas: faGlobeAmericas,
  faP: faP,
  faS: faS,
  faPersonCirclePlus: faPersonCirclePlus,
  faDownload: faDownload,
  faLocationArrow: faLocationArrow,
  faStore: faStore,
  faMoneyBill1: faMoneyBill1,
  faFileInvoiceDollar: faFileInvoiceDollar,
  faFileInvoice: faFileInvoice,
  faUserGear: faUserGear,
  faHandshake: faHandshake,
  faSliders: faSliders,
  faSignOut: faSignOut
};

export default NavBar;
